<ng-container *appFeatureToggle="'mobile'">
  <div class="rider-tip">
    <div class="rider-tip-wrap">
      <div class="rider-tip-heading">ADD TIP FOR RIDER</div>
      <div class="rider-tip-content">The entire amount will be transfered to the driver.</div>
    </div>
    <div class="rider-tip-amount-wrap">
      @for (tipAmount of tipAmounts; track tipAmount) {
        <mat-checkbox class="rider-tip-checkbox" color="primary" [disableRipple]="true"
          (change)="toggleTipAmount(tipAmount, $event)" [checked]="tipAmount == selectedTip">
          <div class="rider-tip-amount" [ngClass]="{'active': tipAmount == selectedTip}">&#8377;&nbsp;{{ tipAmount }}</div>
        </mat-checkbox>
      }
    </div>
  </div>
</ng-container>